module.exports = __webpack_public_path__ + "img/search.0b440473.png";